export default __webpack_public_path__ + "locales/bg/VersionHistory.json?hash=3b08d739fac91e40139b3f610d2667e3";